import React from 'react';
import { useHomeLinksQuery } from '../queryHooks';
import HomeLinksConfigListTable from './HomeLinksConfigListTable';
import { useNavigation } from '../../../utils/navigation';
import { HomeLinkDto } from '../types';

type Props = {
  mCellId: string;
  inventoryCenterId: string;
  mCellCollectionId: string;
};

/**
 * Component Page for managing Home Link Config List
 * @param mCellId
 * @param inventoryCenterId
 * @param mCellCollectionId
 * @constructor
 */
const HomeLinkConfigListPage = ({
  mCellId,
  inventoryCenterId,
  mCellCollectionId,
}: Props) => {
  const { data: homeLinks = [] } = useHomeLinksQuery({
    inventoryCenterId,
    mCellId,
    mCellCollectionId,
  });
  const { navigateToHomeLinkDetailEdit } = useNavigation();

  /**
   * Called when Link row is clicked. Navigates to the Home Link Edit page
   * @param homeLink
   */
  function handleRowClick(homeLink: HomeLinkDto) {
    navigateToHomeLinkDetailEdit(homeLink.id);
  }

  return (
    <HomeLinksConfigListTable
      homeLinks={homeLinks}
      onRowClick={handleRowClick}
    />
  );
};

export default HomeLinkConfigListPage;
